module.exports = __webpack_public_path__ + "img/paper_reading.4e36eb39.png";